import {TrainingStoreState} from "./training-state";

export const initialTrainingStoreState: TrainingStoreState = {
    exam: undefined,
    config: undefined,
    aiGeneratedQuestions: undefined
};